import {
  removeSyllabus,
  getIndexOfNextNonRevisionPhase,
  addSyllabusToNextPhase,
  updateSubjectsArray,
  updateWeekNumbers,
} from '.';
import { combineSyllabus, removeSubjectsFromWeeks } from './moveSyllabus';
import { collectChapters, distributeChapters } from './updatePhaseDetails';

const phaseDelete = (phaseIndex: any, tree: any, setTreeData: Function) => {
  let cloneTree = JSON.parse(JSON.stringify(tree));
  let { phases, totalPhases } = cloneTree;
  const currentPhase = phases[phaseIndex];

  if(currentPhase.isRevision || phaseIndex === totalPhases - 1){
      phases.splice(phaseIndex, 1);
  cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(phases)), totalPhases: totalPhases - 1 };
  setTreeData({ treeData: cloneTree });
  return;
  }

  const index = getIndexOfNextNonRevisionPhase(phaseIndex, phases);
  const nextPhase = phases[index];

  const currentPhaseSyllabus = collectChapters(currentPhase.weeks);
  const nextPhaseSyllabus = collectChapters(nextPhase.weeks);
  const combinedSyllabus = combineSyllabus(currentPhaseSyllabus, nextPhaseSyllabus);

  // prepare new weeks for next phase
  removeSubjectsFromWeeks(nextPhase.weeks);
  let newWeeks = JSON.parse(JSON.stringify(nextPhase.weeks));

  //add syllabus to next non-Revision phase
  newWeeks = distributeChapters(newWeeks, combinedSyllabus);
  nextPhase.weeks = JSON.parse(JSON.stringify(newWeeks));

  phases.splice(phaseIndex, 1);
  updateWeekNumbers(phases);
  updateSubjectsArray(nextPhase);

  cloneTree = { ...cloneTree, phases: JSON.parse(JSON.stringify(phases)), totalPhases: totalPhases - 1 };
  setTreeData({ treeData: cloneTree });
};

export default phaseDelete;
